export const privateUniversityOptions = Array.from(new Set(`
A.K.S. University
A.P.G. (Alakh Prakash Goyal) Shimla University
AAFT University of Media and Arts
Abhilashi University
Abhyuday University
Adamas University
Adani University
Adesh University
Adichunchanagiri University
Agrawan Heritage University
Ahmedabad University
AIPH University
AISECT University
Ajeenkya D.Y. Patil University
Akal University
Al-Falah University
Al-Karim University
Alliance University
Amaltas University
Amity University
Amity University Rajasthan
Anant National University
Anjaneya University
Anurag University
Apeejay Stya University
Apex Professional University
Apex University
ARKA Jain University
Arni University
Arunachal University of Studies
Arunodaya University
Aryavart University
ASBM University
Ashoka University
Asian International University
Assam Don Bosco University
Assam Down Town University
ATLAS SKILLTECH UNIVERSITY
Atmiya University
Atria University
Auniati University
AURO University of Hospitality and Management
Avantika University
Azim Premji University
Baba Mast Nath University
Babu Banarasi Das University
Babu Dinesh Singh University
Baddi University of Emerging Sciences & Technology
Bahra University
Bareilly International University
Bennett University
Bhabha University
Bhagwan Mahavir University
Bhagwant Global University
Bhagwant University
Bhaikaka University
Bharatiya Engineering Science and Technology Innovation University
Bharti Vishwavidyalaya
Bhartiya Skill Development University
Bhupal Nobles University
Bir Tikendrajit University
Birla Global University
BML Munjal University
Brainware University
C.T University
C.U. Shah University
C.V.Raman Global University
Capital University
Career Point University
Centurian University of Technology and Management
Centurion University of Technology and Management
CEPT University (Formerly Centre for Environmental Planning and Technology University)
Chanakya University
Chandigarh University
Charotar University of Science & Technology
Chhatrapati Shivaji Maharaj University
Chirayu University
Chitkara University
CMJ University
CMR University
D.A.V. University
D.Y. Patil Agriculture and Technical University
D.Y.Patil International University
D.Y.Patil University
Darshan University
Dayananda Sagar University
DES Pune University
Desh Bhagat University
Dev Bhoomi Uttrakhand University
Dev Sanskriti Vishwavidyalaya
Dhanalakshmi Srinivasan University
Dhirubhai Ambani Institute of Information and Communication Technology
DIT University
Dr. A.P.J. Abdul Kalam University
Dr. C. V. Raman University
Dr. C.V. Raman University
Dr. C.V.Raman University
Dr. K.N. Modi University
Dr. P. A. Inamdar University
Dr. Preeti Global University
Dr. Subhash University
Dr. Vishwanath Karad MIT World Peace University
DRIEMS University
Drs. Kiran & Pallavi Patel Global University (KPGU)
Durga Soren University
Eklavya University
Era University
Eternal University
F.S. University
Flame University
G.D. Goenka University
G.H. Raisoni University
G.L.A. University
G.L.S. University
G.M University
Galgotias University
Gandhi Institute of Engineering & Technology University
Gandhinagar University
Ganpat University
Garden City University
Geeta University
Geetanjali University
Girijananda Chowdhury University Assam
GNA University
Gokul Global University
Gopal Narayan Singh University
Graphic Era Hill University (Formerly Graphic Era Parvatiya Vishwavidyalaya)
GSFC University
Gujarat Maritime University
Guru Kashi University
Gyanmanjari Innovative University
Gyanveer University
Haridwar University
Himalayan University
Himalayiya University
Himgiri Zee University
Homoeopathy University
I.E.C. (India Education Centre) University
I.E.S University
ICFAI University
IFTM University
IIHMR University
IILM University
IIMT University
IMS Unison University
India International University of Legal Education and Research
Indian Institute of Public Health
Indrashil University
Indus International University
Indus University
Institute of Advanced Research
Institute of Chartered Financial Analysts of India (ICFAI)
Integral University
Invertis University
ISBM University
ITM (SLS) Baroda University
ITM Skills University
ITM University
ITM-Vocational University
J.E.C.R.C. University
J.G.University
J.K. Lakshmipat University
J.N.C.T Professional University
J.S. University
Jagadguru Rambhadracharya Divyang University (Formerly Jagadguru Rambhadracharya Handicapped university)
Jagan Nath University
Jagran Lakecity University
Jai Minesh Adivasi University
Jaipur National University
Jayoti Vidyapeeth Women’s University
Jaypee University
Jaypee University of Engineering & Technology
Jaypee University of Information Technology
Jeppiaar University
Jharkhand Rai University
JIS University
Jodhpur National University
JSPM University
JSS Science & Technology University
K.K. University
K.K.Modi University
K.M (Krishna Mohan) University
K.N University
K.R. Mangalam University
Kadi Sarva Vishwavidyalaya
Kalinga University
Karnavati University
Khaja Bandanawaz University
Khongnangthaba University
Kishkinda University
KLE Technological University
KREA University
Krishnaguru Adhyatmik Vishwavidyalaya
Lakulish Yoga University
Lamrin Tech Skills University
LNCT University
LNCT Vidhyapeeth University
Lok Jagruti Kendra University
Lokbharati University for Rural Innovation
Lords University
Lovely Professional University
M.S. Ramaiah University of Applied Sciences
M.V.N. University
Madhav University
Madhyanchal Professional University
Maganbhai Adenwala Mahagujarat University
Mahakaushal University
Mahapurusha Srimanta Sankaradeva Viswavidyalaya
Maharaj Vinayak Global University
Maharaja Agrasen Himalayan Garhwal University (Formerly Himalayan Garhwal University)
Maharaja Agrasen University
Maharashi Markandeshwar University
Maharishi Arvind University
Maharishi Mahesh Yogi Vedic Vishwavidyalaya
Maharishi Markandeshwar University
Maharishi University of Information Technology
Maharishi University of Management and Technology
Mahatma Gandhi University
Mahatma Gandhi University of Medical Sciences & Technology
Mahatma Jyoti Rao Phoole University
Mahaveer University
Mahayogi Gorakhnath University Gorakhpur
Mahindra University
Major S.D.Singh University
Malla Reddy University
Malwanchal University
Manav Bharti University
Manav Rachna University
Mandsaur University
Mangalayatan University
Manipal University
Manipur International University
Mansarovar Global University
Martin Luther Christian University
Marwadi University
Mata Gujri University
MATS University
Maulana Azad University
Medhavi Skills University
Medi-Caps University
Mewar University
MGM University
MIT Art Design & Technology University
Mody University of Science and Technology
Mohammad Ali Jauhar University
Mohan Babu University
Monad University
Monark University
Motherhood University
Navrachana University
Netaji Subhas University
NICMAR University
NIILM University
NIIT University
Nims University
Nirma University
Nirwan University
Noble University
Noida International University
North East Adventist University
North East Christian University
North East Frontier Technical University
O.P. Jindal Global University
O.P. Jindal University
Om Sterling Global University
OPJS University
Oriental University
P. P. Savani University
P.K. University
Pacific Academic of Higher Education & Research University
Pacific Medical University
Pandit Deendayal Energy University (Formerly Pandit Deendayal Petroleum University)
Parul University
PDM University
People’s University
PES University
Pimpri Chinchwad University
Plaksha University Punjab
Plastindia International University
Poornima University
Pragjyotishpur University
Pragyan International University
Pratap University
Presidency University (Karnataka)
Prestige University
Quantum University
R.K. University
R.N.B. Global University
Rabindranath Tagore University (Formerly AISECT University)
Radha Govind University
Raffles University
Rai Technology University
Rai University
Rajju Shroff Rofel University (RSRU)
Ram Krishana Dharmarth Foundation University
Rama University
Ramchandra Chandravansi University
Ras Bihari Bose Subharti University
Rayat Bahra University
Renaissance University
Reva University
RIMT University
Rishihood University
RKDF University
RV University
Sabarmati University
Sage University
Sai Nath University
Sai Tirupati University
Sai University
SAM Global University
Sandip University
Sangai International University
Sangam University
Sanjay Ghodawat University
Sanjeev Agrawal Global Educational University
Sankalchand Patel University
Sanskriti University
Sant Baba Bhag Singh University
Sardar Bhagwan Singh University
Sardar Patel University
Sardar Vallabhbhai Global University
Sarla Birla University
Sarvajanik University
Sarvepalli Radhakrishnan University
Saveetha Amaravati University
Scope Global Skills University
SDGI Global University
Seacom Skills University
Sharda University
Sharnbasva University
Shiv Nadar University
Shobhit University
Shoolini University of Biotechnology and Management Sciences
Shree Guru Gobind Singh Tricentenary University
Shreyarth University
Shri Dharmasthala Manjunatheshwara University
Shri Guru Ram Rai University
Shri Jagdish Prasad Jhabarmal Tibrewala University
Shri Khushal Das University
Shri Krishna University
Shri Ramasamy Memorial University
Shri Ramswaroop Memorial University
Shri Rawatpura Sarkar University
Shri Shankaracharaya Professional University
Shri Vaishnav Vidyapeeth Vishwavidyalaya
Shri Venkateshwara University
Shridhar University
Shubham University
Shyam University
Sigma University
Sikkim Alpine University (Formerly EIILM University)
Sikkim International University
Sikkim Manipal University
Sikkim Professional University (Formerly Vinayaka Missions Sikkim University)
Sikkim Skill University
Silver Oak University
Singhania University
Sir Padmapat Singhania University
Sister Nivedita University
SKIPS University
Somaiya Vidyavihar University
Sona Devi University
Spicer Adventist University
SR University
Sri Aurobindo University
Sri Balaji University
Sri Guru Granth Sahib World University
Sri Guru Ram Das University of Health Sciences
Sri Jagadhguru Murugarajendra University
Sri Sai University
Sri Sathya Sai University for Human Excellence
Sri Satya Sai University of Technology & Medical Sciences
Sri Sri University
Srinath University
Srinivas University
SRM University
St. Joseph University
St. Joseph’s University
St. Xavier’s University
Starex University
Sunrise University
Surajmal University
Surendranagar University
Suresh Gyan Vihar University
Sushant University (Formerly Ansal University)
Swami Rama Himalayan University
Swami Vivekanand Subharti University
Swami Vivekanand University
Swami Vivekananda University
Swaminarayan University
Swarnim Startup & Innovation University
Symbiosis Skills and Professional University (Formerly Symbiosis Skills and Open University)
Symbiosis University of Applied Sciences
T.S Mishra University
Tantia University
Team Lease Skills University
Techno Global University
Techno India University
Teerthanker Mahaveer University
The Appolo University
The Aryavart International University
The Assam Kaziranga University
The Assam Royal Global University
The Charutar Vidya Mandal (CVM) University
The Global Open University
The Global University
The Glocal University
The ICFAI University
The ICFAI University Sikkim
The Indira Gandhi Technological & Medical Sciences University
The Institute of Chartered Financial Analysts of India University
The Neotia University
The Northcap University (Formerly ITM University)
The University of Trans-Disciplinary Health Sciences and Technology
Transstadia University
UKA Tarsadia University
United University
Universal Ai University
University of Engineering & Management
University of Engineering and Management
University of Engineering and Technology Roorkee
University of Patanjali
University of Petroleum and Energy Studies
University of Science & Technology
University of Technology
UPL University of Sustainable Technology
Usha Martin University
Uttaranchal University
Vanita Vishram Women’s University
Venkateshwara Open University
Vidhyadeep University
Vidyashilp University
Vijaybhoomi University
Vikrant University
Vishwakarma University
VIT Bhopal University
VIT-AP University
Vivekananda Global University
William Carey University
World University of Design
Woxsen University
XIM University (Formerly Xavier University)
YBN University
Jawahar Lal Nehru University
B.L.D.E. University, Bijapur
Bangalore University, Bangalore
Davangere University, Davangere
Gulbarga University, Gulbarga
JSS ACADEMY OF HIGHER EDUCATION & RESEARCH
K.L.E. Academy of Higher Education and Research, Belgaum
Kannada University, Hampi, Kamalapura
Karnataka State Law University, Hubli
Karnataka State Women University, Bijapur
Karnataka University, Dharwad
Karnataka Vetrinary, Animal & Fisheries Science University, Nandinagar
Kuvempu University, Shankaraghatta, Shimoga
Mangalore University, Mangalore
Manipal Academy of Higher Education, Manipal
Mysore University, Mysore
National Institute of Technology, Karnataka
NITTE Unversity, Mangalore
Rajiv Gandhi University of Health Sciences, Bangalore
Sri Devraj Urs Acaedmy of Highehr Education and Research, Kolar
Sri Siddharatha Acedemy of Higher Education
Tumkur University, Tumkur
University of Horticultural Sciences, Bagalkot
University of Agricultural Sciences, Dharwad
University of Agricultural Sciences, Raichur
University of Agricultural Sciences, Bangalore
Vesveswaraiah Technological University, Belgaum
Yenepoya University, Mangalore
Dakshina Bharat Hindi Prachar Sabha
Rani Channamma University, Belagavi
Vijayanagara Sri Krishnadevaraya University, Bellary
Karnataka Sanskrit University
UNIVERSITY OF AGRICULTURAL AND HORTICULTURAL SCIENCES, SHIMOGA
PES UNIVERSITY, BANGLORE
INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, DHARWAD
CBSE
ICSE
Karnataka PU Board
Bangalore Central University
Bangalore North University
Deemed University
Industrial Training & Employment
Karnataka State Diploma in Nursing Examination Board
Govt of Karnataka
Govt of India
`
  .trim()
  .split('\n')
  .map((option) => option.trim())
  .filter(Boolean)));
